import { createFileRoute } from '@tanstack/react-router';

import { OprView } from '../../raporty/opr/OprView';

export const Route = createFileRoute('/raporty/oprogramowanie')({
  component: OprView,
});
